<template>
  <v-container fluid class="legal-page pa-0">
    <section class="hero d-flex align-center justify-center">
      <v-container>
        <v-row justify="center">
          <v-col cols="12" md="9" lg="8">
            <v-card class="legal-card pa-8">
              <v-btn
                text
                color="primary"
                class="mb-4"
                @click="goBack"
              >
                <v-icon left>mdi-arrow-left</v-icon>
                Volver
              </v-btn>

              <div class="text-center mb-6">
                <v-img
                  src="/logo.png"
                  contain
                  height="90"
                  class="mx-auto mb-4"
                />
                <h1 class="font-weight-bold">
                  Aviso Legal de Kalendario
                </h1>
                <p class="effective-date">
                  Fecha de entrada en vigor: 15 de mayo de 2026 | Última actualización: 15 de mayo de 2026
                </p>
              </div>

              <div class="legal-text">
                <h2>1. Información General</h2>
                <p>
                  En cumplimiento de la normativa aplicable sobre servicios de la sociedad de la información y comercio electrónico, incluida la Ley 34/2002, de Servicios de la Sociedad de la Información y de Comercio Electrónico —LSSI-CE—, se informa a los usuarios de que el sitio web y la aplicación Kalendario, accesibles desde
                  <a href="https://kalendario.thevalkiria.com" target="_blank" rel="noopener noreferrer">
                    https://kalendario.thevalkiria.com
                  </a>,
                  son responsabilidad de:
                </p>
                <ul>
                  <li><strong>Titular / Responsable:</strong> Sorraylla Ramos</li>
                  <li>
                    <strong>Correo electrónico de contacto:</strong>
                    <a href="mailto:valkiria.lab.apps@gmail.com">valkiria.lab.apps@gmail.com</a>
                  </li>
                  <li>
                    <strong>Sitio web:</strong>
                    <a href="https://kalendario.thevalkiria.com" target="_blank" rel="noopener noreferrer">
                      https://kalendario.thevalkiria.com
                    </a>
                  </li>
                  <li><strong>País:</strong> España</li>
                </ul>

                <h2>2. Objeto</h2>
                <p>
                  El presente Aviso Legal regula el acceso, navegación y uso del sitio web y de la aplicación Kalendario. El uso de Kalendario implica la aceptación de este Aviso Legal en la versión publicada en cada momento.
                </p>
                <p>
                  Kalendario es un servicio destinado a facilitar la creación, gestión y compartición de calendarios, eventos y grupos entre usuarios.
                </p>

                <h2>3. Condiciones de Uso</h2>
                <p>
                  El usuario se compromete a utilizar Kalendario de forma lícita, diligente y respetuosa con la normativa aplicable, la buena fe, el orden público y los derechos de terceros. En particular, el usuario se compromete a no:
                </p>
                <ul>
                  <li>Utilizar el servicio con fines ilícitos, fraudulentos o no autorizados.</li>
                  <li>Introducir información falsa, inexacta, ofensiva o que vulnere derechos de terceros.</li>
                  <li>Acceder o intentar acceder a cuentas, datos o sistemas de otros usuarios sin autorización.</li>
                  <li>Interferir en el funcionamiento normal del servicio o comprometer su seguridad.</li>
                  <li>Introducir datos sensibles propios o de terceros sin base legal o autorización suficiente.</li>
                </ul>
                <p>
                  El usuario deberá respetar en todo momento las normas de conducta y usos prohibidos establecidos en este Aviso Legal.
                </p>

                <h2>4. Uso Prohibido y Normas de Conducta</h2>
                <p>
                  El usuario se compromete a utilizar Kalendario de forma lícita, responsable y conforme a la normativa vigente, a la buena fe, al orden público y a los derechos de terceros.
                </p>
                <p>Queda expresamente prohibido el uso de Kalendario para:</p>
                <ul>
                  <li>Publicar, compartir, almacenar o difundir contenido violento, sexual, pornográfico o que incluya desnudos explícitos.</li>
                  <li>Promover, fomentar o justificar el odio, la discriminación, el acoso, la intimidación o la violencia por razón de raza, sexo, religión, orientación sexual, identidad de género, discapacidad, nacionalidad, origen étnico, edad u otras circunstancias personales o sociales.</li>
                  <li>Compartir contenido ilegal, ofensivo, difamatorio, amenazante, abusivo o que infrinja derechos de terceros.</li>
                  <li>Introducir, compartir o tratar datos personales de terceros sin autorización o sin una base legal suficiente.</li>
                  <li>Introducir datos sensibles, como información de salud, ideología, religión, orientación sexual, datos biométricos o similares, salvo que exista autorización suficiente y una base legal válida.</li>
                  <li>Suplantar la identidad de otras personas, entidades o usuarios.</li>
                  <li>Utilizar la aplicación con fines fraudulentos, abusivos, engañosos o contrarios a la buena fe.</li>
                  <li>Introducir malware, virus, código dañino, spam, automatizaciones abusivas o cualquier elemento que pueda dañar la aplicación, sus sistemas o a otros usuarios.</li>
                  <li>Intentar acceder sin autorización a cuentas, datos, calendarios, eventos, grupos, sistemas o áreas restringidas de Kalendario.</li>
                  <li>Interferir, sobrecargar, bloquear, alterar o perjudicar el funcionamiento normal del servicio.</li>
                  <li>Usar Kalendario de forma contraria a las políticas de Google Play, App Store u otras plataformas de distribución aplicables.</li>
                  <li>Utilizar Kalendario de cualquier forma contraria a la legislación aplicable.</li>
                </ul>
                <p>
                  El incumplimiento de estas normas podrá dar lugar a la suspensión, limitación o eliminación de la cuenta del usuario, así como a la eliminación de contenidos, calendarios, eventos o grupos que incumplan estas condiciones, sin perjuicio de las acciones legales que pudieran corresponder.
                </p>

                <h2>5. Registro e Inicio de Sesión</h2>
                <p>
                  Para utilizar determinadas funcionalidades de Kalendario, el usuario puede iniciar sesión mediante su cuenta de Google. La autenticación se realiza a través de Firebase Authentication y Google como proveedor de identidad.
                </p>
                <p>
                  El usuario es responsable de mantener la seguridad de su cuenta de Google y de cualquier actividad realizada desde su cuenta en Kalendario.
                </p>

                <h2>6. Disponibilidad del Servicio</h2>
                <p>
                  Kalendario se ofrece procurando mantener un funcionamiento correcto y seguro. No obstante, no se garantiza la disponibilidad continua, ininterrumpida o libre de errores del servicio.
                </p>
                <p>
                  El servicio puede verse afectado por tareas de mantenimiento, actualizaciones, incidencias técnicas, fallos de proveedores externos o causas de fuerza mayor.
                </p>

                <h2>7. Responsabilidad del Usuario</h2>
                <p>
                  El usuario es responsable de la información que introduce en calendarios, eventos, grupos o cualquier otra funcionalidad del servicio. El usuario garantiza que cuenta con los derechos, permisos o autorizaciones necesarios para introducir, compartir o tratar información de terceros dentro del servicio.
                </p>
                <p>
                  El usuario será responsable de los daños o perjuicios que pudieran derivarse del uso indebido del servicio o del incumplimiento de este Aviso Legal.
                </p>

                <h2>8. Responsabilidad de Kalendario</h2>
                <p>
                  Kalendario no se responsabiliza de los daños derivados de un uso indebido del servicio por parte de los usuarios, de la introducción de información incorrecta o no autorizada, ni de decisiones tomadas por los usuarios a partir de la información almacenada en calendarios, eventos o grupos.
                </p>
                <p>
                  Kalendario tampoco será responsable de interrupciones, errores o problemas derivados de servicios de terceros necesarios para el funcionamiento del servicio, como plataformas de alojamiento, autenticación, base de datos o analytics.
                </p>

                <h2>9. Propiedad Intelectual e Industrial</h2>
                <p>
                  El diseño, estructura, código, textos, elementos gráficos, marcas, nombres comerciales, logotipos y demás contenidos propios de Kalendario están protegidos por derechos de propiedad intelectual e industrial, salvo que se indique lo contrario.
                </p>
                <p>
                  El acceso o uso del servicio no otorga al usuario ningún derecho de propiedad sobre dichos contenidos. Queda prohibida su reproducción, distribución, comunicación pública, transformación o cualquier otro uso no autorizado, salvo autorización expresa del titular o cuando esté permitido por la ley.
                </p>

                <h2>10. Contenido Introducido por los Usuarios</h2>
                <p>
                  Los usuarios conservan los derechos que les correspondan sobre la información, calendarios, eventos, textos u otros contenidos que introduzcan en Kalendario.
                </p>
                <p>
                  Al utilizar el servicio, el usuario autoriza a Kalendario a almacenar, procesar y mostrar dichos contenidos únicamente en la medida necesaria para prestar las funcionalidades del servicio, como la gestión de calendarios, eventos, grupos, sincronización y colaboración entre usuarios.
                </p>

                <h2>11. Enlaces a Terceros</h2>
                <p>
                  Kalendario puede incluir enlaces a sitios web, servicios o plataformas de terceros. Estos enlaces se proporcionan únicamente para facilitar el acceso a información o servicios relacionados.
                </p>
                <p>
                  Kalendario no controla ni se responsabiliza del contenido, funcionamiento, disponibilidad, seguridad o políticas de privacidad de dichos sitios o servicios externos. El usuario debe revisar las condiciones y políticas aplicables de cada tercero antes de utilizarlos.
                </p>

                <h2>12. Protección de Datos</h2>
                <p>
                  El tratamiento de datos personales derivado del uso de Kalendario se regula en la
                  <router-link to="/privacy-policy">Política de Privacidad</router-link>
                  disponible en el sitio web o aplicación. Para cualquier consulta o solicitud relacionada con protección de datos, el usuario puede contactar en:
                  <a href="mailto:valkiria.lab.apps@gmail.com">valkiria.lab.apps@gmail.com</a>.
                </p>

                <h2>13. Cookies</h2>
                <p>
                  El uso de cookies y tecnologías similares se regula en la Política de Cookies de Kalendario, disponible en el sitio web o aplicación.
                </p>

                <h2>14. Modificaciones</h2>
                <p>
                  Kalendario se reserva el derecho a modificar este Aviso Legal para adaptarlo a cambios legales, técnicos, operativos o funcionales. La versión actualizada será aplicable desde su publicación o desde la fecha indicada como entrada en vigor.
                </p>
                <p>
                  Se recomienda al usuario revisar periódicamente este Aviso Legal.
                </p>

                <h2>15. Legislación Aplicable y Jurisdicción</h2>
                <p>
                  Este Aviso Legal se rige por la legislación española y, en lo que resulte aplicable, por la normativa de la Unión Europea.
                </p>
                <p>
                  Para la resolución de controversias, las partes se someterán a los juzgados y tribunales que resulten competentes conforme a la normativa aplicable. Cuando el usuario tenga la condición de consumidor, se respetarán los fueros legalmente establecidos.
                </p>

                <h2>16. Contacto</h2>
                <p>
                  Para cualquier consulta relacionada con este Aviso Legal, puedes contactar con:
                </p>
                <ul>
                  <li><strong>Responsable:</strong> Sorraylla Ramos</li>
                  <li>
                    <strong>Sitio web:</strong>
                    <a href="https://kalendario.thevalkiria.com" target="_blank" rel="noopener noreferrer">
                      https://kalendario.thevalkiria.com
                    </a>
                  </li>
                  <li>
                    <strong>Email:</strong>
                    <a href="mailto:valkiria.lab.apps@gmail.com">valkiria.lab.apps@gmail.com</a>
                  </li>
                </ul>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </section>
  </v-container>
</template>

<script>
export default {
  name: 'LegalNotice',
  methods: {
    goBack() {
      if (window.history.length > 1) {
        this.$router.back();
        return;
      }

      this.$router.push("/");
    }
  }
}
</script>

<style scoped>
.legal-page {
  min-height: 100vh;
}

.hero {
  min-height: 100vh;
}

.legal-card {
  border-radius: 10px;
  box-shadow: 0 30px 70px rgba(0, 0, 0, 0.25);
}

.effective-date {
  color: #666;
  font-size: 0.95rem;
  margin-top: 12px;
}

.legal-text p,
.legal-text li {
  color: #444;
  line-height: 1.7;
}

.legal-text p {
  margin-bottom: 16px;
}

.legal-text ul {
  margin-bottom: 16px;
  padding-left: 22px;
}

.legal-text li {
  margin-bottom: 8px;
}

.legal-text h2 {
  margin-top: 28px;
  margin-bottom: 10px;
  font-size: 1.35rem;
  font-weight: 700;
}

.legal-text a {
  color: #4f46e5;
  font-weight: 600;
  text-decoration: none;
  overflow-wrap: anywhere;
}

.legal-text a:hover {
  text-decoration: underline;
}
</style>
